<template>
  <div class="main shadow">
    <div style="display: flex;position: absolute;top:17%">
      <div class="loginLeft">
      </div>
      <div style="width:450px;background-color: white;padding:10px 40px;margin-top:15px;height: 460px;margin-left: 80px;  ">
        <a-form :form="form" class="user-layout-login" ref="formLogin" id="formLogin">
          <a-tabs
            :activeKey="customActiveKey"
            :tabBarStyle="{ textAlign: 'left', borderBottom: 'unset' }"
            @change="handleTabClick">
            <a-tab-pane key="tab1" tab="账号登录">
              <a-form-item style="margin-top: 10px;">
                <a-input
                  size="large"
                  v-decorator="['username',validatorRules.username,{ validator: this.handleUsernameOrEmail }]"
                  type="text"
                  placeholder="请输入账号">
                  <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
                </a-input>
              </a-form-item>

              <a-form-item>
                <a-input
                  v-decorator="['password',validatorRules.password]"
                  size="large"
                  type="password"
                  autocomplete="false"
                  placeholder="请输入密码">
                  <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }"/>
                </a-input>
              </a-form-item>

              <a-row :gutter="0">
                <a-col :span="16">
                  <a-form-item>
                    <a-input
                      v-decorator="['inputCode',validatorRules.inputCode]"
                      size="large"
                      type="text"
                      @change="inputCodeChange"
                      placeholder="请输入验证码">
                      <a-icon slot="prefix" type="safety-certificate" :style="{ color: 'rgba(0,0,0,.25)' }"/>
                    </a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="8" style="text-align: right">
                  <img v-if="requestCodeSuccess" style="margin-top: 2px;" :src="randCodeImage" @click="handleChangeCheckCode"/>
                  <img v-else style="margin-top: 2px;" src="../../assets/checkcode.png" @click="handleChangeCheckCode"/>
                </a-col>
              </a-row>
              <a-form-item style="margin-top:15px">
                <a-button
                  size="large"
                  type="primary"
                  htmlType="submit"
                  class="login-button"
                  :loading="loginBtn"
                  @click.stop.prevent="handleSubmit"
                  :disabled="loginBtn">登&nbsp;&nbsp;录
                </a-button>
              </a-form-item>

              <div>
                <a-checkbox v-decorator="['rememberMe', {initialValue: true, valuePropName: 'checked'}]" v-show="false" >自动登录</a-checkbox>
<!--                <router-link :to="{ name: 'alteration'}">
                  忘记密码？
                </router-link>-->
                <a href="https://fzztb.fzsggzyjyfwzx.cn/portal/newsInfo?id=1723947120983515137" target="_blank">忘记密码？</a>
                <span style="float: right;">首次登录平台，请<router-link :to="{ name: 'register'}">点击注册</router-link></span>
<!--                <span style="float: right;">首次登录平台，请<a href="http://www.fzztb.com/EbidEnterpriseWeb/TmEnterpriseRegister/regist.xhtml" target="_blank">点击注册</a></span>-->
              </div>
            </a-tab-pane>

            <a-tab-pane key="tab2" tab="专家人脸登录">
              <a-form-item style="margin-top: 10px;">
                <a-input
                  size="large"
                  v-decorator="['idCard',validatorRules.idCard]"
                  type="text"
                  placeholder="请输入账号">
                  <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
                </a-input>
              </a-form-item>

              <a-form-item>
                <a-input
                  v-decorator="['name',validatorRules.name]"
                  size="large"
                  type="text"
                  placeholder="请输入姓名">
                  <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
                </a-input>
              </a-form-item>

              <a-form-item style="margin-top:30px">
                <a-button
                  size="large"
                  type="primary"
                  htmlType="submit"
                  class="login-button"
                  @click.stop.prevent="expertLoginClick">人脸识别登录
                </a-button>
              </a-form-item>
            </a-tab-pane>

            <a-tab-pane key="tab3" tab="省平台登录">
              <a-form-item style="margin-top:30px">
                <a-button
                  size="large"
                  type="primary"
                  htmlType="submit"
                  class="login-button"
                  @click.stop.prevent="uniteLoginClick">福建省公共服务平台用户登录
                </a-button>
              </a-form-item>
            </a-tab-pane>
          </a-tabs>
        </a-form>

        <two-step-captcha
          v-if="requiredTwoStepCaptcha"
          :visible="stepCaptchaVisible"
          @success="stepCaptchaSuccess"
          @cancel="stepCaptchaCancel"></two-step-captcha>
        <login-select-tenant ref="loginSelect" @success="loginSelectOk" v-show="false"></login-select-tenant>
        <third-login ref="thirdLogin" v-show="false"></third-login>

        <Appraise-login-select-modal ref="appraiseModalForm"></Appraise-login-select-modal>

      </div>
    </div>
  </div>
</template>

<script>
//import md5 from "md5"
import api from '@/api'
import TwoStepCaptcha from '@/components/tools/TwoStepCaptcha'
import { mapActions } from "vuex"
import { timeFix } from "@/utils/util"
import Vue from 'vue'
import { ACCESS_TOKEN ,ENCRYPTED_STRING} from "@/store/mutation-types"
import { putAction,postAction,getAction } from '@/api/manage'
import { encryption , getEncryptedString } from '@/utils/encryption/aesEncrypt'
import store from '@/store/'
import { USER_INFO } from "@/store/mutation-types"
import ThirdLogin from './third/ThirdLogin'
import LoginSelectTenant from "./LoginSelectTenant";
import md5 from '@/utils/md5.js'
import JSEncrypt from 'jsencrypt'
import AppraiseLoginSelectModal from "@views/bobidappraise/AppraiseLoginSelectModal.vue";

export default {
  components: {
    AppraiseLoginSelectModal,
    LoginSelectTenant,
    TwoStepCaptcha,
    ThirdLogin
  },
  data () {
    return {
      customActiveKey: "tab1",
      loginBtn: false,
      // login type: 0 email, 1 username, 2 telephone
      loginType: 0,
      requiredTwoStepCaptcha: false,
      stepCaptchaVisible: false,
      form: this.$form.createForm(this),
      enterpriseInfo:{},
      userInfoAll:{},
      encryptedString:{
        key:"",
        iv:"",
      },
      state: {
        time: 60,
        smsSendBtn: false,
      },
      validatorRules:{
        username:{rules: [{ required: true, message: '请输入账号!'},{validator: this.handleUsernameOrEmail}]},
        password:{rules: [{ required: true, message: '请输入密码!',validator: 'click'}]},
        mobile:{rules: [{validator:this.validateMobile}]},
        captcha:{rule: [{ required: true, message: '请输入验证码!'}]},
        inputCode:{rules: [{ required: true, message: '请输入验证码!'}]},
        name:{rules: [{ required: true, message: '请输入姓名!'}]},
        idCard: { rules: [{ required: true,validator:this.checkIDCard }] },
      },
      verifiedCode:"",
      inputCodeContent:"",
      inputCodeNull:true,
      currentUsername:"",
      currdatetime:'',
      randCodeImage:'',
      requestCodeSuccess:false,
      uniteLoginUrl:'',
      interval:'',
    }
  },
  created () {
    if (this.$route.query.code != null && this.$route.query.code != "") {
      this.customActiveKey = "tab3"
      let loginParams = {};
      loginParams.code = this.$route.query.code
      let that = this;
      this.UniteLogin(loginParams).then((res) => {
        if(res.success) {
          that.$refs.loginSelect.show(res.result)
        } else {
          that.$message.error(res.message);
        }
      }).catch((err) => {
        that.$message.error("登录异常！");
      })
    } else {
      this.currdatetime = new Date().getTime();
      Vue.ls.remove(ACCESS_TOKEN)
      this.getRouterData();
      this.handleChangeCheckCode();
    }
    // update-begin- --- author:scott ------ date:20190805 ---- for:密码加密逻辑暂时注释掉，有点问题
    //this.getEncrypte();
    // update-end- --- author:scott ------ date:20190805 ---- for:密码加密逻辑暂时注释掉，有点问题
  },
  methods: {
    ...mapActions(['Login', 'Logout', 'PhoneLogin', 'UniteLogin', 'faceLogin']),
    // handler
    handleUsernameOrEmail (rule, value, callback) {
      const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;
      if (regex.test(value)) {
        this.loginType = 0
      } else {
        this.loginType = 1
      }
      callback()
    },
    checkIDCard (rule, value, callback) {
      const IDCardReg = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(([0-2][1-9])|10|20|30|31)\d{3}(\d|X)$/
      // const sfzhReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      if (value) {
        if (IDCardReg.test(value)) {
          callback()
        } else {
          callback(new Error('身份证号格式不正确'))
        }
      } else {
        callback(new Error('请输入身份证号'))
      }
    },
    handleTabClick (key) {
      this.customActiveKey = key
      if ( (this.uniteLoginUrl == null || this.uniteLoginUrl == '') && key == "tab3" ) {
        let that = this;
        getAction("/sys/getUniteLoginUrl",{})
          .then(res => {
            if(res.success) {
              that.uniteLoginUrl = res.result;
            }
          })
          .catch(err => {
            that.$message.error(err.message)
          });
      }
      // this.form.resetFields()
    },
    uniteLoginClick() {
      if (this.uniteLoginUrl == null || this.uniteLoginUrl == '') {
        this.$message.error("登录链接获取异常，请稍后重试！");
        return
      }
      window.location.href = this.uniteLoginUrl;
    },
    expertLoginClick() {
      clearInterval(this.interval)
      let that = this;
      that.form.validateFields([ 'name', 'idCard' ], { force: true }, (err, values) => {
        if (!err) {
          postAction('/sys/loadExpertLoginCode').then(res => {
            if (res.success) {
              let param = {}
              param.token = res.result;
              param.username = values.name.trim();
              param.idcard = values.idCard.trim().toLowerCase();
              param.params = res.result;
              param.url = `${window._CONFIG['frameAppraiseCallbackURL']}` + "/ebid-ce/boExperts/faceLogin";
              let jsonParam = JSON.stringify(param);
              var buffer = new Buffer(jsonParam);
              var base64String = buffer.toString('base64')
              let result = base64String;
              let href ="rkccommonqualityjudge://" +result;
              window.open(href,'_blank');
              that.interval = window.setInterval(() => {
                let p = {}
                p.username = values.idCard.trim();
                p.token = res.result;
                that.faceLogin(p).then(res => {
                  if (res.success) {
                    that.userInfoAll=res.result;
                    that.$refs.loginSelect.show(res.result)
                    clearInterval(that.interval)
                  }
                })
              }, 3000);
            }
          }).catch((err) => {
          })
        } else {
        }
      })
    },
    handleSubmit () {
      let that = this
      let loginParams = {};
      that.loginBtn = true;
      // 使用账户密码登录
      if (that.customActiveKey === 'tab1') {
        that.form.validateFields([ 'username', 'password','inputCode', 'rememberMe' ], { force: true }, (err, values) => {
          if (!err) {

            postAction("/sys/loadRsa").then(res=>{
              if(res.success){
                loginParams.username = values.username
                loginParams.remember_me = false
                loginParams.captcha = that.inputCodeContent
                loginParams.checkKey = that.currdatetime
                loginParams.publicKey = res.result

                //私钥
                let publicKey = res.result
                let encryptor = new JSEncrypt();
                encryptor.setPublicKey(publicKey);
                let encrypedPwd = encryptor.encrypt(values.password)
                loginParams.password  = encrypedPwd

                that.Login(loginParams).then((res) => {
                  that.enterpriseInfo=res.result.enterpriseInfo;
                  that.userInfoAll=res.result;
                  this.$refs.loginSelect.show(res.result)
                }).catch((err) => {
                  that.requestFailed(err);
                });
              }
            }).catch((err) => {
              that.requestFailed(err);
            });
          }else {
            that.loginBtn = false;
          }
        })
        // 使用手机号登录
      } else {
        that.form.validateFields([ 'mobile', 'captcha', 'rememberMe' ], { force: true }, (err, values) => {
          if (!err) {
            loginParams.mobile = values.mobile
            loginParams.captcha = values.captcha
            loginParams.remember_me = values.rememberMe
            that.PhoneLogin(loginParams).then((res) => {
              this.$refs.loginSelect.show(res.result)
            }).catch((err) => {
              that.requestFailed(err);
            })
          }
        })
      }
    },
    getCaptcha (e) {
      e.preventDefault();
      let that = this;
      this.form.validateFields([ 'mobile' ], { force: true },(err,values) => {
          if(!values.mobile){
            that.cmsFailed("请输入手机号");
          }else if (!err) {
            this.state.smsSendBtn = true;
            let interval = window.setInterval(() => {
              if (that.state.time-- <= 0) {
                that.state.time = 60;
                that.state.smsSendBtn = false;
                window.clearInterval(interval);
              }
            }, 1000);

            const hide = this.$message.loading('验证码发送中..', 0);
            let smsParams = {};
            smsParams.mobile=values.mobile;
            smsParams.smsmode="0";
            postAction("/sys/sms",smsParams)
              .then(res => {
                if(!res.success){
                  setTimeout(hide, 0);
                  this.cmsFailed(res.message);
                }
                console.log(res);
                setTimeout(hide, 500);
              })
              .catch(err => {
                setTimeout(hide, 1);
                clearInterval(interval);
                that.state.time = 60;
                that.state.smsSendBtn = false;
                this.requestFailed(err);
              });
          }
        }
      );
    },
    stepCaptchaSuccess () {
      this.loginSuccess()
    },
    stepCaptchaCancel () {
      this.Logout().then(() => {
        this.loginBtn = false
        this.stepCaptchaVisible = false
      })
    },
    handleChangeCheckCode(){
      this.currdatetime = new Date().getTime();
      getAction(`/sys/randomImage/${this.currdatetime}`).then(res=>{
        if(res.success){
          this.randCodeImage = res.result
          this.requestCodeSuccess=true
        }else{
          this.$message.error(res.message)
          this.requestCodeSuccess=false
        }
      }).catch(()=>{
        this.requestCodeSuccess=false
      })
      // 登录失败、异常、重新获取验证码时，将验证码输入框置为空
      this.form.setFieldsValue({
        'inputCode': ''
      });
    },
    loginSuccess () {
      if(this.enterpriseInfo.approvalStatus == '1' || this.enterpriseInfo.approvalStatus == '4'){
        this.$router.push({ path: "/ienterprise/enterpriseInfo" }).catch(()=>{
          console.log('登录跳转首页出错,这个错误从哪里来的')
        });
      }else{
        if(this.userInfoAll.userInfo.roleCode==="expert")
        {
          this.$refs.appraiseModalForm.load(this.userInfoAll);
        }
       else{
          this.$router.push({ path: "/dashboard/analysis" }).catch((err)=>{
            console.log('登录跳转首页出错,这个错误从哪里来的')
          });
          this.$notification.success({
            message: '欢迎',
            description: `${timeFix()}，欢迎回来`,
          });
        }
        // this.$router.push({ path: "/dashboard/analysis" }).catch((err)=>{
        //   console.log('登录跳转首页出错,这个错误从哪里来的')
        // });
      }
    },
    cmsFailed(err){
      this.$notification[ 'error' ]({
        message: "登录失败",
        description:err,
        duration: 4,
      });
    },
    requestFailed (err) {
      this.handleChangeCheckCode()
      this.$notification[ 'error' ]({
        message: '登录失败',
        description: ((err.response || {}).data || {}).message || err.message || "请求出现错误，请稍后再试",
        duration: 4,
      });
      this.loginBtn = false;
    },
    validateMobile(rule,value,callback){
      if (!value || new RegExp(/^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/).test(value)){
        callback();
      }else{
        callback("您的手机号码格式不正确!");
      }

    },
    validateInputCode(rule,value,callback){
      if(!value || this.verifiedCode==this.inputCodeContent){
        callback();
      }else{
        callback("您输入的验证码不正确!");
      }
    },
    generateCode(value){
      this.verifiedCode = value.toLowerCase()
    },
    inputCodeChange(e){
      this.inputCodeContent = e.target.value
    },
    loginSelectOk(){
      this.loginSuccess()
    },
    getRouterData(){
      this.$nextTick(() => {
        if (this.$route.params.username) {
          this.form.setFieldsValue({
            'username': this.$route.params.username
          });
        }
      })
    },
    //获取密码加密规则
    getEncrypte(){
      var encryptedString = Vue.ls.get(ENCRYPTED_STRING);
      if(encryptedString == null){
        getEncryptedString().then((data) => {
          this.encryptedString = data
        });
      }else{
        this.encryptedString = encryptedString;
      }
    },
  }
}
</script>

<style lang="less" scoped>
.loginLeft{
  width:680px;
  height: 500px;
  background: url(~@/assets/loginBg.png);
  background-size: 100% 100%;
  /*padding: 60px 0 144px;*/
  position: relative;
}
.user-layout-login {
  label {
    font-size: 14px;
  }

  .forge-password {
    font-size: 14px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0,0,0,.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color .3s;

      &:hover {
        color: #1890ff;
      }
    }

    .register {
      float: right;
    }
  }
}
</style>
<style>
.valid-error .ant-select-selection__placeholder{
  color: #f5222d;
}
</style>